import { render, staticRenderFns } from "./OrderDetailsView.vue?vue&type=template&id=d121c998"
import script from "./OrderDetailsView.vue?vue&type=script&lang=js"
export * from "./OrderDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports